/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Property_HandoverInputs */

const cs_enum_property_handover = /** @type {(inputs: Enum_Property_HandoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Předání nemovitosti`)
};

const en_enum_property_handover = /** @type {(inputs: Enum_Property_HandoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handover`)
};

/**
* | output |
* | --- |
* | "Handover" |
*
* @param {Enum_Property_HandoverInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_property_handover = /** @type {((inputs?: Enum_Property_HandoverInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Property_HandoverInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_property_handover(inputs)
	return cs_enum_property_handover(inputs)
});